import { render, staticRenderFns } from "./BlockCover.vue?vue&type=template&id=ced00994"
import script from "./BlockCover.vue?vue&type=script&lang=js"
export * from "./BlockCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports